import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Hind-eng/Auth/Login";
import SideNavBar from "./Hind-eng/sidebar";
import NavBar from "./Hind-eng/navbar";
import TaskData from "./Hind-eng/pDetails";
import ProductAdd from "./Hind-eng/productAdd";
import ProductEditForm from "./Hind-eng/productEdit";
import ContactUs from "./Hind-eng/contactus";
import Category from "./Hind-eng/category";
import Carousal from "./Hind-eng/heroImages";
import BackgroundImage from "./Hind-eng/backgroundImage";
import AboutUs from "./Hind-eng/aboutus";
import AboutUsSection from "./Hind-eng/aboutus-section";
import TechnicalSkills from "./Hind-eng/techinical-skills";
import IndustrialSolutions from "./Hind-eng/industrial-solutions";
import "./App.css";

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const AppContent = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation(); 

  const pathToTitle = {
    "/": "Product Details",
    "/product-add": "Add Product",
    "/product-details": "Product Details",
    "/category-details": "Categories",
    "/enquiry-details": "Enquiry Details",
    "/carousel-details": "Hero Images",
    "/background-image": "Background Images",
    "/aboutus-page":"AboutUs Page",
    "/techinical-skills":"Technical Skills",
    "/industrial-solutions":"Industrial Solutions",
    "/aboutus-section":"AboutUs Section",

  };

  const OpenPage = pathToTitle[location.pathname] || "Product Details";

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <SideNavBar
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
        setIsCollapsed={setIsSidebarCollapsed}
        setOpenPage={OpenPage}
      />

      <div
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
          isSidebarCollapsed ? "ml-[3.5rem]" : "ml-[13.9rem]"
        }`}
      >
        <NavBar title={OpenPage} />

        <div className="flex-1 overflow-auto bg-gray-100">
          <Routes>
            <Route path="/" element={<TaskData />} />
            {/* <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user-details" element={<UserData isSidebarCollapsed={isSidebarCollapsed} />} /> */}
            <Route path="/product-add" element={<ProductAdd />} />
            {/* <Route path="/task-edit/:id" element={<TaskEdit />} />
            <Route path="/task-details/:taskGroupId" element={<TaskDataById />} /> */}
            <Route path="/product-edit/:id" element={<ProductEditForm />} />
            <Route path="/product-details" element={<TaskData />} />
            <Route path="/category-details" element={<Category />} />
            <Route path="/enquiry-details" element={<ContactUs />} />
            <Route path="/carousel-details" element={<Carousal />} />
            <Route path="/background-image" element={<BackgroundImage />} />
            <Route path="/aboutus-page" element={<AboutUs />} />
            <Route path="/aboutus-section" element={<AboutUsSection />} />
            <Route path="/techinical-skills" element={<TechnicalSkills />} />
            <Route path="/industrial-solutions" element={<IndustrialSolutions />} />
            
            {/* <Route path="/delete-request" element={<DeleteRequest />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      {/* <Route path="/delete-account" element={<DeleteAccount />} /> */}

      {/* Protected Routes */}
      <Route
        path="*"
        element={
          <RequireAuth>
            <AppContent />
          </RequireAuth>
        }
      />
    </Routes>

    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  </BrowserRouter>
);

export default App;
